import DinesLogoWithTitle from "@/components/Logos/DinesLogoWithTitle";
import { faChevronDoubleLeft, faTimes } from "@/icons/solid-icons";
import { cn } from "@/utils/css";
import Icon from "@dinesapp/dines-ui/components/Icon";
import { useEffect, useState } from "react";

interface ISideBarTitle {
  collapseSidebar: boolean;
  setCollapseSidebar: (collapseSidebar: boolean) => void;
  menuOpen: boolean;
  toggleMenu: () => void;
}

const SideBarTitle: React.FC<ISideBarTitle> = ({
  collapseSidebar,
  setCollapseSidebar,
  menuOpen,
  toggleMenu,
}) => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const query = window.matchMedia("(min-width: 768px)");
    const onChange = () => setIsDesktop(query.matches);
    onChange();
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  const toggleDesktopCollapse = () => {
    if (isDesktop) {
      setCollapseSidebar(!collapseSidebar);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={toggleDesktopCollapse}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleDesktopCollapse();
        }
      }}
      className={cn(
        "mt-4 mb-3 flex w-full shrink-0 items-center justify-between bg-dines-purple-darkest px-8 pt-4 pb-4 outline-none transition-all duration-150 focus:outline-none md:mb-0 md:cursor-pointer",
        collapseSidebar && "md:justify-center md:px-0",
      )}
    >
      <div
        className={cn(
          "flex transition-opacity duration-150",
          collapseSidebar && "md:pointer-events-none md:absolute md:opacity-0",
        )}
      >
        <DinesLogoWithTitle />
      </div>

      <div className="hidden md:my-4 md:flex">
        <Icon
          icon={faChevronDoubleLeft}
          size="lg"
          className={cn(
            "mt-1 cursor-pointer transition-transform duration-150",
            collapseSidebar && "rotate-180",
          )}
        />
      </div>

      {menuOpen && (
        <div className="md:hidden">
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleMenu();
            }}
          >
            <Icon icon={faTimes} size="lg" />
          </button>
        </div>
      )}
    </div>
  );
};

export default SideBarTitle;
